import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-94" data-mp="20mo695urcx7g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-95" data-mp="24n86wjejiiyc">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-success/25 bg-white p-8 shadow-card sm:p-10" data-id="element-96" data-mp="24lx3wlsx5f8a">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success/10" data-id="element-97" data-mp="2ja9pcoudrfoj">
            <ShieldCheckIcon size={32} className="text-success" data-id="element-98" data-mp="2obz52hsjshiy" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-bold uppercase leading-tight text-ink sm:text-3xl" data-id="element-99" data-mp="2sc96ri9b4ls0">
            Garantía de Satisfacción de 7 Días
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-100" data-mp="xxzwzb1733jd">
            Si el producto no cumple con lo prometido, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-brown underline" data-id="element-101" data-mp="3nuq6sadhdm7e">
              manualeslistos@gmail.com
            </a>{' '}
            y te ayudaremos a resolverlo en menos de 24 horas.
          </p>

          <p className="mx-auto mt-4 max-w-xl text-sm font-semibold text-ink" data-id="element-102" data-mp="3dxlh40kff8lu">
            Queremos artesanos facturando, no coleccionistas de PDFs.
          </p>

          <p className="mt-6 text-xs text-muted sm:text-sm" data-id="element-103" data-mp="afts8v1l74rv">
            +5.200 personas ya lo usan. Nuestra tasa de devolución es menor al 1%.
          </p>
        </m.div>
      </div>
    </section>;
}